import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { SharedService } from 'src/app/services/shared.service';
import { Utility } from 'src/app/core/common';
import { AuthState, Logout, Update } from 'src/app/states/auth.state';
import { Router } from '@angular/router';

@Component({
  selector: 'user-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class UserProfileComponent implements OnInit, OnDestroy {

  constructor(private store: Store, private spinner: SpinnerService, private sharedService: SharedService,
    private userService: UserService, private router: Router) {
    if (this.sharedService.isBrowser)
      AuthState.user$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(user => {
          this.current = Utility.clone(user);
          if (!this.current.Employer) {
            if (!this.current.Seeker) {
              this.current.Seeker = {};
            }
          }
        });
  }

  current: any;
  section: any;

  progress: number;

  ngOnInit() { }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async update() {
    this.spinner.show();
    await this.store.dispatch(new Update(this.current)).toPromise();
    this.spinner.hide();
  }
  // async addCv(file: File) {
  //   this.spinner.show('cv');
  //   await this.userService.addCv(file, progress => this.progress = progress);
  //   delete this.progress;
  //   this.spinner.hide('cv');
  // }

  // async removeCv() {
  //   this.spinner.show('cv');
  //   await this.userService.removeCv();
  //   delete this.CvContent;
  //   this.CvContainer.nativeElement.childNodes.forEach(_ => _.remove());
  //   this.spinner.hide('cv');
  // }

  // @ViewChild('Cv', { static: false }) CvContainer: ElementRef<HTMLDivElement>;
  // CvContent: string;
  // async getCv(download = false) {
  //   this.spinner.show('cv');
  //   var file = !this.CvContent ? await this.userService.getCv() :
  //     Object.assign({}, this.current.Seeker.CV, { Content: this.CvContent });
  //   this.CvContent = file.Content;

  //   if (download) {
  //     // var blob = new Blob([file.Content], { type: file.ContentType });
  //     var link = document.createElement('a');
  //     link.href = 'data:application/octet-stream;base64,' + file.Content;
  //     link.download = file.Name;
  //     link.click();
  //   }
  //   else {
  //     // var bin = atob(file.Content);
  //     var obj = document.createElement('object');
  //     obj.style.width = '100%';
  //     obj.style.height = '842pt';
  //     obj.type = file.ContentType;
  //     obj.data = 'data:' + file.ContentType + ';base64,' + file.Content;
  //     this.CvContainer.nativeElement.childNodes.forEach(_ => _.remove());
  //     this.CvContainer.nativeElement.appendChild(obj);
  //   }
  //   this.spinner.hide('cv');
  // }

  codeSent: boolean;
  async sendDeleteCode() {
    this.spinner.show();
    await this.userService.sendDeleteAccountCode();
    this.codeSent = true;
    this.spinner.hide();
  }
  async deleteAccount(code: string) {
    this.spinner.show();
    await this.userService.deleteAccount(code);
    this.store.dispatch(Logout);
    this.router.navigateByUrl('/');
  }
}
